var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"scout-button",attrs:{"disabled":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",function(){return [_vm._v("スカウト対象")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }